<template>
  <div class="dashboard">
    <moon-nav></moon-nav>
    <main class="main">
      <div class="main-content">
        <router-view />
      </div>
    </main>
  </div>
</template>
<script lang="ts" setup>
import MoonNav from "@/components/nav/MoonNav.vue";
</script>
<style>
@import "@/assets/styles/auth.css";
@import "vue-multiselect/dist/vue-multiselect.css";

.view-dashboard-route {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-items: center;
  align-items: center;
}

.circular-border {
  box-sizing: border-box;
  border-radius: 50%;
  outline: var(--color-border-secondary) var(--dimension-avatar-border-width)
    solid;
  box-shadow: 0 0.3rem 0.6rem var(--color-shadow);
}

.router-link-active .circular-border {
  outline-color: var(--color-background);
}

.user-avatar-small .circular-border {
  outline-width: var(--dimension-avatar-border-width-small);
}

.moon-card {
  width: 100%;
  height: 100%;
  background-color: var(--color-background);
  border-radius: 0.5rem;
  box-sizing: border-box;
  padding: 1.2rem 2.8rem 2.8rem 2.8rem;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}

.moon-card-title {
  align-self: center;
}

.moon-card-title-small {
  align-self: center;
  color: var(--color-text-hint);
  font-size: 0.8em;
}

.invert {
  filter: invert(100%);
}

.icon img {
  width: 100%;
  height: 100%;
}

.modal-actions {
  width: 100%;
  padding: 0 3.2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.login-card {
  background-color: var(--color-background);
  width: 48rem;
  min-height: 32rem;
  border-radius: 1.2rem;
  box-shadow: 0 0.3rem 0.5rem rgb(0 0 0 / 15%);
}

@media only screen and (max-width: 37rem) {
  .login-card {
    width: 100%;
    min-height: unset;
    box-shadow: none;
    align-items: flex-start;
    justify-self: flex-start;
  }
}
</style>
<style scoped>
.dashboard {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow-y: scroll;
}

.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-background-soft);
  overflow-x: scroll;
}

.main-content {
  width: 100%;
  height: 100%;
  padding: 0 2.4rem;
  max-width: 120rem;
}

@media only screen and (max-width: 62rem) {
  .dashboard {
    flex-direction: column;
  }
}

@media only screen and (max-width: 37.5rem) {
  .main-content {
    margin: 0.4rem;
  }
}
</style>
